import { createFileRoute } from '@tanstack/react-router';
import NewObjectPage from '@/pages/workspaces/objects/new-object.page';
import { ObjectsMigrationRoute } from '@/pages/workspaces/objects/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/objects/$slug/new')({
  component: () => (
    <ObjectsMigrationRoute>
      <NewObjectPage />
    </ObjectsMigrationRoute>
  ),
});
